import * as superagent from 'superagent'
import * as sentry from '../../src/utils/sentry'
import { fetchS3UrlBothQuality } from '../../../app-core/lib/file/withS3Url'
import { Base_commonDeps } from '../Base/Base.commonDeps'
import { IDB_cachedImages } from '../IDB/IDB.deviceDB'
import _ from 'lodash'

export async function Imag_cacheImages(imageUrls: string[]) {
    if (imageUrls.length === 0) return

    // Exclude imageUrls if they already exist in the indexed db
    const imageUrlsToCache = await excludeAlreadyCachedImages(imageUrls)

    for (const imageUrl of imageUrlsToCache) {
        try {
            await Imag_cache(imageUrl, false)
        } catch (error) {
            sentry.err(error, { extra: { imageUrl } })
        }
    }
}

async function excludeAlreadyCachedImages(imageUrls: string[]): Promise<string[]> {
    // Check in indexed db if any images have been cached already
    const cachedUrls = (await IDB_cachedImages().where(':id').anyOf(imageUrls).keys()) as string[]

    // Remove existing cached image urls from imageUrls array
    const imageUrlsToCache = _.difference(imageUrls, cachedUrls)

    return imageUrlsToCache
}

export async function isAlreadyCached(imageUrl: string): Promise<boolean> {
    return !!(await IDB_cachedImages().get(imageUrl))
}

export async function getFromCache(imageUrl: string): Promise<Blob | undefined> {
    const cachedImage = await IDB_cachedImages().get(imageUrl)
    return cachedImage?.data
}

export function removeFromCache(imageUrl: string) {
    return IDB_cachedImages().delete(imageUrl)
}

export async function Imag_cache(imageUrl: string, existenceCheck: boolean = true, preferThumbnail = true) {
    // Don't try to download a null or undefined imageUrl
    if (!imageUrl) return null

    // Don't re-download images that we've already cached
    if (existenceCheck && (await isAlreadyCached(imageUrl))) return null

    // Get the s3 url for an image
    const { thumbnailS3Url, fullSizeS3Url } = await fetchS3UrlBothQuality(Base_commonDeps(), imageUrl)
    const s3url = preferThumbnail ? thumbnailS3Url : fullSizeS3Url

    // Fetch the image. If no s3 url, use original url
    const response = await superagent.get(s3url ?? imageUrl).responseType('blob')

    // If it failed, then don't cache
    if (!response.ok) return null

    const data: Blob = response.body

    // Otherwise cache the image in IDB
    await IDB_cachedImages().put({ data }, imageUrl)

    // Return image if needed
    return data
}
